import { NavLink } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react'
import { ProductItems, LayoutItems, PriceItems, UserItems, BottomItems } from 'config/MenuItems'
import { CreditCardIcon, LayoutIcon, ProductIcon, UserIcon } from 'components/svg'
import SubMenu from './ExpanableMenu';

interface SideBarProps {
  customClass?: string;
  navOpen?: boolean;
  setNavClose?(): void;
}

const SideBar = (props: SideBarProps) => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(false)
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  const checkScrollable = () => {
    if (scrollContainerRef.current) {
      const { scrollHeight, clientHeight, scrollTop } = scrollContainerRef.current
      const isScrollable = scrollHeight > clientHeight
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1
      setShowScrollIndicator(isScrollable && !isAtBottom)
    }
  }

  useEffect(() => {
    checkScrollable()
    // Check on window resize
    const handleResize = () => checkScrollable()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <aside className={`bg-gray-700 shadow-lg w-52 min-w-max bg-opacity-60 md:h-screen transition-all ease duration-200 h-full ${props.customClass}`}>
      <div className='justify-between flex flex-col h-full'>
        {/* Header */}
        <div className="flex items-center justify-center h-16 flex-shrink-0">
          <h1 className="font-bold text-white">Kupid Admin</h1>
        </div>

        {/* Scrollable Menu Content */}
        <div className='flex-1 overflow-hidden relative'>
          <div 
            ref={scrollContainerRef}
            className='h-full overflow-y-auto overflow-x-hidden scrollbar-thin scrollbar-track-gray-600 scrollbar-thumb-gray-400 hover:scrollbar-thumb-gray-300'
            onScroll={checkScrollable}
          >
            <ul className="flex flex-col pb-4">
              <SubMenu
                title="Products & Categories"
                icon={ProductIcon}
                items={ProductItems}
                initialExpand={true}
                setNavClose={props.setNavClose || (() => {})}
              />
              <SubMenu
                title="Button Styles & Layout"
                icon={LayoutIcon}
                items={LayoutItems}
                initialExpand={true}
                setNavClose={props.setNavClose || (() => {})}
              />
              <SubMenu
                title="Pricing"
                icon={CreditCardIcon}
                items={PriceItems}
                initialExpand={true}
                setNavClose={props.setNavClose || (() => {})}
              />
              <SubMenu
                title="Users & Settings"
                icon={UserIcon}
                items={UserItems}
                setNavClose={props.setNavClose || (() => {})}
                initialExpand={true}
              />
            </ul>
          </div>
          
          {showScrollIndicator && (
            <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-gray-800 to-transparent pointer-events-none opacity-30"></div>
          )}
        </div>

        {/* Bottom Menu */}
        <div className='border-t border-gray-600 border-opacity-40 py-1.5 flex-shrink-0'>
          <ul>
            {BottomItems.map((item) => (
              <li key={item.routeName} onClick={props.setNavClose}>
                <NavLink
                  to={item.routeName}
                  className="flex items-center py-2 pl-3 text-center text-sm rounded-lg mx-2 my-0.5 text-white opacity-80 hover:opacity-100 hover:bg-gray-300 hover:bg-opacity-20"
                  activeClassName="bg-gray-800 opacity-80"
                >
                  {item.icon}
                  <span className="ml-3 text-gray-200">{item.title}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  )
}

export default SideBar